export const formatString = function (str: string, args: any[] | null) {
	if (!args) {
		return str;
	}
	return str.replace(/{(\d+)}/g, function (match, number) {
		return typeof args[number] != "undefined"
			? args[number]
			: match;
	});
};

export const formatStringArgs = function (str: string, ...args: any[]) {
	return formatString(str, args);
};

export const formatPrice = function (value: number, currency = "USD") {
	const priceFormatter = new Intl.NumberFormat((new Intl.NumberFormat()).resolvedOptions().locale, {
		style: "currency",
		currency: currency,
		maximumFractionDigits: 2,
		minimumFractionDigits: 0,
	});
	return priceFormatter.format(value);
};


export const normalizeString = function (str: string) {
	return str
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase();
};